// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__N_sS_","box":"WorkspacesBox_box__21Tx_","node":"WorkspacesBox_node__nQjng"};